module.exports = __webpack_public_path__ + "img/Bjornson_Aulestad.cc76d780.jpg";